import { Art } from '@/modules/marketing/SiteArt';
import type { ArtProps } from '@/modules/marketing/SiteArt';

/**
 * The illustrations for automation, Auto-Fix and backup verification, by the names the pages import.
 *
 * Pictures drawn by `scripts/site-art.py` and shown by `SiteArt`. Each shows the mechanism the
 * article describes: one procedure on three distributions, one command on four servers, a canary
 * and a confirmation, a failure repaired without an alert.
 */

/** One procedure, three distributions, the same result on each. */
export function PlaybookArt({ priority }: ArtProps = {}) {
  return <Art name="playbooks" priority={priority} />;
}

/** Connections meeting a firewall: SSH let through, the rest stopped, and the undo. */
export function HardeningArt({ priority }: ArtProps = {}) {
  return <Art name="hardening" priority={priority} />;
}

/** One command reaching many servers, each with its own outcome, and a retry of the failed one. */
export function CommandFanoutArt({ priority }: ArtProps = {}) {
  return <Art name="command-runner" priority={priority} />;
}

/** Preflight, a dry run, one canary server, a person's confirmation, then the batches. */
export function CanaryArt({ priority }: ArtProps = {}) {
  return <Art name="safe-rollouts" priority={priority} />;
}

/** Steps run in order, ending in a server that is ready for its job. */
export function TemplateArt({ priority }: ArtProps = {}) {
  return <Art name="templates" priority={priority} />;
}

/** A record of runs, newest first, each with its outcome, and the output one server returned. */
export function RunHistoryArt({ priority }: ArtProps = {}) {
  return <Art name="run-history" priority={priority} />;
}

/** A failure noticed, a small fix applied, and the line recovering with no alert sent. */
export function AutoFixArt({ priority }: ArtProps = {}) {
  return <Art name="auto-fix" priority={priority} />;
}

/** A copy fetched back, checked, loaded into a scratch database and read back. */
export function RestoreTestArt({ priority }: ArtProps = {}) {
  return <Art name="restore-test" priority={priority} />;
}
